/**
 * Which build am I on? (dev handoff 2026-09-21, `vtt-error-release-tag-unknown`)
 *
 * `RELEASE` and `BUILD_ID` are compile-time constants from vite.config.ts
 * (`define`), which reads VITE_RELEASE / VITE_BUILD_ID off the environment:
 *
 *   - in CI:    RELEASE = short commit SHA ("d33cc40"), BUILD_ID = Azure
 *               Build.BuildId ("224"). The build FAILS if VITE_RELEASE is unset.
 *   - locally:  RELEASE = "local-<short sha>", BUILD_ID = "" (with a warning).
 *   - vitest:   the defines aren't applied, so both fall back here.
 *
 * Consumers: errorCapture (stamped on every error payload → ErrorsTable →
 * vtt-errors `error_stats.by_release`), `<html data-release>`, the Admin
 * page's build footer, and a one-line `console.info` at boot.
 */

function readDefine(read: () => unknown): string {
  try {
    const v = read();
    return typeof v === 'string' ? v.trim() : '';
  } catch {
    return '';
  }
}

export const RELEASE: string = readDefine(() => __VTT_RELEASE__) || 'unknown';
export const BUILD_ID: string = readDefine(() => __VTT_BUILD_ID__);

/** "d33cc40 (build 224)" / "local-d33cc40" / "unknown" — for humans. */
export function releaseLabel(release: string = RELEASE, buildId: string = BUILD_ID): string {
  return buildId ? `${release} (build ${buildId})` : release;
}

/** True when this bundle came out of the pipeline rather than a dev machine. */
export function isPipelineRelease(release: string = RELEASE): boolean {
  return release !== 'unknown' && !release.startsWith('local-');
}
